// 商行详情 — 小票打印模板配置（码单、销售单）
import React, { PureComponent } from 'react';
import { Table } from '@/components';
import { message } from 'antd-v5';
import {
  STALL_THERMAL_PRINTER_MEMO_EDIT_PATH,
  STALL_THERMAL_PRINTER_ORDER_EDIT_PATH,
  STALL_THERMAL_PRINTER_TAB_KEY,
} from './thermalPrinterTemplateShared';
import './thermalPrinterTemplate.less';

class StallThermalPrinterTemplate extends PureComponent {
  goEdit = (pathname) => {
    const { history, stallId, marketId } = this.props;
    if (!history || !stallId) {
      message.error('无法跳转，请刷新页面重试');
      return;
    }
    history.push({
      pathname,
      state: {
        stallId,
        marketId,
        tab: STALL_THERMAL_PRINTER_TAB_KEY,
      },
    });
  };

  render() {
    const columns = [
      {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 100,
      },
      {
        title: '模板名称',
        dataIndex: 'templateName',
        key: 'templateName',
      },
      {
        title: '操作',
        key: 'action',
        width: 160,
        render: (_, record) => (
          <a
            href='/'
            className='thermalTemplateEditLink'
            onClick={(e) => {
              e.preventDefault();
              record.onEdit();
            }}
          >
            编辑
          </a>
        ),
      },
    ];
    const dataSource = [
      {
        key: 'memo',
        index: 1,
        templateName: '码单模板',
        onEdit: () => this.goEdit(STALL_THERMAL_PRINTER_MEMO_EDIT_PATH),
      },
      {
        key: 'order',
        index: 2,
        templateName: '销售单模板',
        onEdit: () => this.goEdit(STALL_THERMAL_PRINTER_ORDER_EDIT_PATH),
      },
    ];

    return (
      <div className='stallThermalPrinterTemplate'>
        <Table
          rowKey='key'
          columns={columns}
          dataSource={dataSource}
          pagination={false}
        />
      </div>
    );
  }
}

export default StallThermalPrinterTemplate;
